import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;


const FeaturePage = styled.div`
  background: linear-gradient(to right, #d28710 0%, #f39c12 100%);
  color: #fff;
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;

  @media (max-width: 480px) {
    min-height: 80vh;
   
  }
`;

const Content = styled.div`
  max-width: 800px;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  animation: ${fadeIn} 1s ease-in-out;

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 2.5rem;
  }
`;

const Description = styled.p`
  font-size: 1.5rem;
  margin-bottom: 15px;
  line-height: 1.5;
  opacity: 0;
  animation: ${fadeIn} 1s ease-in-out forwards;

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;



export const Features = () => {
  const [visibleIndex, setVisibleIndex] = useState(0);
  const lines = [
    "Tangled up in Green is a uniquely designed sustainable community by Total Environment, located on Doddaballapur Main Road, next to the Bangalore Satellite Town Ring Road [STRR].",
    "At the heart of the community is a central boulevard with a park that runs from the entrance of the property through to the end of the property, providing a wonderful walking space among the trees within this central park.",
    "Trees are some of the most beautiful creations of nature. Housed in the central park, is an 8 acres tree museum celebrating a carefully curated selection of trees with information about their history and background, benefits and other interesting facts.",
    "RERA No: PRM/KA/RERA/1251/446/AG/201012/002062.",
  ];

  useEffect(() => {
    if (visibleIndex < lines.length) {
      const timer = setTimeout(() => {
        setVisibleIndex(visibleIndex + 1);
      }, 1000); 
      return () => clearTimeout(timer);
    }
  }, [visibleIndex, lines.length]);

  return (
    <FeaturePage id="features">
      <Content>
        <Title>Plotted Development the Total Environment Way</Title>
        {lines.map((line, index) => (
          <Description
            key={index}
            style={{
              animationDelay: `${index * 1}s`,
              opacity: visibleIndex > index ? 1 : 0,
            }}
          >
            {line}
          </Description>
        ))}
       
      </Content>
    </FeaturePage>
  );
};
